<template>
  <v-container fluid
               class="booking-inspection-container"
               v-if="singleInspectionBooking.hasOwnProperty('guests') === true">
    <v-layout row wrap>
      <v-flex lg6 md6 sm12 xs12 class="left-panel">
        <!-- BOOKING DETAILS SECTION -->
        <v-flex lg12>
          <v-expansion-panel popout class="custom-expansion-panel">
            <v-expansion-panel-content>
              <template slot="actions">
                <v-icon color="primary">$vuetify.icons.expand</v-icon>
              </template>
              <div slot="header" class="panel-header">
                <h5>BOOKING DETAILS</h5>
              </div>
              <v-card class="details-card">
                <v-container>
                  <v-card-text class="details-content">
                    <ol>
                      <li>
                        <v-flex>
                          <li>
                            <span class="detail-label">Booking ref:</span>
                            <span class="detail-value">{{ singleInspectionBooking.booking_ref_code }}</span>
                          </li>
                          <li>
                            <span class="detail-label">First name:</span>
                            <span class="detail-value">{{ singleInspectionBooking.booking_details.first_name }}</span>
                          </li>
                          <li>
                            <span class="detail-label">Last name:</span>
                            <span class="detail-value">{{ singleInspectionBooking.booking_details.last_name }}</span>
                          </li>
                          <li>
                            <span class="detail-label">Phone Number:</span>
                            <span class="detail-value">{{ singleInspectionBooking.booking_details.phone_number }}</span>
                          </li>
                          <li>
                            <span class="detail-label">Email:</span>
                            <span class="detail-value">{{ singleInspectionBooking.booking_details.email_address }}</span>
                          </li>
                          <li>
                            <span class="detail-label">Destination:</span>
                            <span class="detail-value">{{ singleInspectionBooking.destination }}</span>
                          </li>
                          <li>
                            <span class="detail-label">Address:</span>
                            <span class="detail-value">{{ singleInspectionBooking.booking_details.address }}</span>
                          </li>
                          <li>
                            <span class="detail-label">Booking by:</span>
                            <span class="detail-value">{{ singleInspectionBooking.session_user }}</span>
                          </li>
                          <li>
                            <span class="detail-label">Created at:</span>
                            <span class="detail-value">{{ formated_date_time(singleInspectionBooking.created_at) }}</span>
                          </li>
                          <li v-if="singleInspectionBooking.partner_booking_ref !== null">
                            <span class="detail-label">Partner Booking Ref:</span>
                            <span class="detail-value">{{ singleInspectionBooking.partner_booking_ref }}</span>
                          </li>
                          <li>
                            <span class="detail-label">Client Note:</span>
                            <span class="detail-value">{{ singleInspectionBooking.booking_details.additional_note }}</span>
                          </li>
                        </v-flex>

                        <v-flex v-if="singleInspectionBooking.school_booking === true">
                          <li>
                            <span class="detail-label">School Name:</span>
                            <span class="detail-value">{{ singleInspectionBooking.school_booking_details[0].school_name }}</span>
                          </li>
                          <li>
                            <span class="detail-label">School Level:</span>
                            <span class="detail-value">{{ singleInspectionBooking.school_booking_details[0].school_level }}</span>
                          </li>
                          <li>
                            <span class="detail-label">School Code:</span>
                            <span class="detail-value">{{ singleInspectionBooking.school_booking_details[0].school_code }}</span>
                          </li>
                          <li>
                            <span class="detail-label">School Type:</span>
                            <span class="detail-value">{{ singleInspectionBooking.school_booking_details[0].school_type }}</span>
                          </li>
                          <li>
                            <span class="detail-label">Teacher Name:</span>
                            <span class="detail-value">{{ singleInspectionBooking.school_booking_details[0].primary_contact }}</span>
                          </li>
                          <li>
                            <span class="detail-label">Teacher Email:</span>
                            <span class="detail-value">{{ singleInspectionBooking.school_booking_details[0].primary_contact_email }}</span>
                          </li>
                          <li>
                            <span class="detail-label">Teacher Phone Number:</span>
                            <span class="detail-value">{{ singleInspectionBooking.school_booking_details[0].primary_contact_phone }}</span>
                          </li>
                        </v-flex>

                        <v-flex lg4 v-if="singleInspectionBooking.corporate_booking === true">
                          <li>
                            <span class="detail-label">Company Name:</span>
                            <span class="detail-value">{{ singleInspectionBooking.corporate_booking_details[0].organisation_name }}</span>
                          </li>
                        </v-flex>

                        <v-flex lg4 v-if="singleInspectionBooking.partner_name !== null">
                          <li>
                            <span class="detail-label">Partner Name:</span>
                            <span class="detail-value">{{ singleInspectionBooking.partner_name }}</span>
                          </li>
                          <li>
                            <span class="detail-label">Agent Email Address:</span>
                            <span class="detail-value">{{ singleInspectionBooking.agent_email }}</span>
                          </li>
                        </v-flex>

                        <hr class="divider" />

                        <h4 class="section-header">Office Notes</h4>
                        <v-card v-for="(note, key) in singleInspectionBooking.booking_notes"
                                :key="key"
                                class="note-card">
                          <v-container fluid>
                            <p>
                              <v-chip small
                                      color="primary"
                                      text-color="black"
                                      v-if="note.show_on_invoice === true">
                                public
                              </v-chip>
                              <v-chip small
                                      v-else
                                      class="internal-chip">
                                internal
                              </v-chip>
                            </p>
                            <p class="note-content">
                              <span class="note-label">Note: </span>
                              {{ note.note }}
                            </p>
                            <p class="note-meta">
                              <span class="meta-label">Note by: </span>
                              {{ note.user }}
                              <span class="meta-label">at </span>
                              {{ formated_date_time(note.created_at) }}
                            </p>
                          </v-container>
                        </v-card>
                      </li>
                    </ol>
                  </v-card-text>
                </v-container>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>

        <!-- ENTRY PAX & VEHICLES SECTION -->
        <v-flex lg12>
          <v-expansion-panel popout class="custom-expansion-panel">
            <v-expansion-panel-content>
              <template slot="actions">
                <v-icon color="primary">$vuetify.icons.expand</v-icon>
              </template>
              <div slot="header" class="panel-header">
                <h5>ENTRY PAX & VEHICLES ({{ totalGuestsVehicles() }})</h5>
              </div>
              <v-card class="details-card">
                <v-container>
                  <v-card-text class="details-content">
                    <ol>
                      <!-- ===== GUEST ROWS WITH INLINE VERIFICATION ===== -->
                      <li v-for="(guest, idx) in singleInspectionBooking.guests"
                          :key="'guest-' + idx"
                          v-if="guest.payment_guests > 0"
                          class="guest-item guest-item-with-verification">
                        <div class="guest-row-main">
                          <span class="guest-type">{{ guest.payment_person }}</span> :
                          {{ guest.payment_guests }} @
                          {{ guest.payment_person_amount }}
                          <span class="discount-badge">[Discount: {{ guest.payment_person_discount }}%]</span>
                        </div>

                        <div class="guest-row-verification">
                          <template v-if="isGuestVerifiable(guest)">
                            <v-chip small
                                    :color="getVerifiedCountForGuest(guest) === guest.payment_guests ? 'success' : 'warning'"
                                    text-color="white"
                                    class="verification-chip">
                              <v-icon small left>
                                mdi-{{ getVerifiedCountForGuest(guest) === guest.payment_guests ? 'check-circle' : 'alert-circle' }}
                              </v-icon>
                              {{ getVerifiedCountForGuest(guest) }}/{{ guest.payment_guests }} verified
                            </v-chip>

                            <v-chip small outlined
                                    :color="getGuestDocTypeColor(guest)"
                                    class="ml-2 doc-type-chip">
                              <v-icon small left>mdi-{{ getGuestDocTypeIcon(guest) }}</v-icon>
                              {{ getGuestDocTypeLabel(guest) }}
                            </v-chip>

                            <!-- Inline image view icon (kept as per requirement) -->
                            <v-btn v-if="getGuestVerifiedImages(guest).length > 0"
                                   small
                                   icon
                                   color="#74a533"
                                   @click="viewGuestVerificationImages(guest)"
                                   class="ml-1"
                                   title="View Verification Images">
                              <v-icon small>mdi-image-multiple</v-icon>
                            </v-btn>
                            <v-btn v-else
                                   small
                                   icon
                                   disabled
                                   color="grey"
                                   class="ml-1"
                                   title="No images">
                              <v-icon small>mdi-image-off</v-icon>
                            </v-btn>

                            <span v-if="getGuestVerifiedImages(guest).length > 0"
                                  class="ml-1 grey--text caption">
                              ({{ getGuestVerifiedImages(guest).length }})
                            </span>
                          </template>

                          <template v-else>
                            <v-chip small color="grey" text-color="white" class="verification-chip">
                              <v-icon small left>mdi-check-circle</v-icon>
                              Exempt
                            </v-chip>
                          </template>
                        </div>
                      </li>

                      <hr class="divider" v-if="singleInspectionBooking.vehicles.length > 0" />

                      <li v-for="(vehicle, idx) in singleInspectionBooking.vehicles"
                          :key="'vehicle-' + idx"
                          v-if="vehicle.vehicles > 0"
                          class="vehicle-item">
                        <span class="vehicle-type">{{ vehicle.vehicle_charge_category }}</span>
                        : {{ vehicle.vehicles }} @
                        {{ vehicle.vehicle_charge_category_cost }}
                        <span class="discount-badge">[Discount: {{ vehicle.discount }}%]</span>
                      </li>

                      <v-divider v-if="singleInspectionBooking.vehicle_details.length > 0" class="divider" />

                      <h5 v-if="singleInspectionBooking.vehicle_details.length > 0" class="section-header">
                        VEHICLE DETAILS
                      </h5>

                      <v-container>
                        <li v-if="singleInspectionBooking.vehicle_details.length > 0"
                            v-for="(details, idx) in singleInspectionBooking.vehicle_details"
                            :key="'vdetails-' + idx"
                            class="vehicle-detail-item">
                          <p>
                            <span class="detail-label">Driver's Name: </span>
                            <span class="detail-value">{{ details.check_vehicle_driver }}</span>
                          </p>
                          <p>
                            <span class="detail-label">Driver's Phone Number: </span>
                            <span class="detail-value">{{ details.check_vehicle_phone_number }}</span>
                          </p>
                          <p>
                            <span class="detail-label">Vehicle Registration: </span>
                            <span class="detail-value">{{ details.check_vehicle_reg }}</span>
                          </p>
                          <p>
                            <span class="detail-label">Vehicle Disc: </span>
                            <span class="detail-value">{{ details.check_vehicle_disc }}</span>
                          </p>
                          <hr class="divider" />
                        </li>
                      </v-container>

                      <!-- VIEW ALL PAX / RESIDENCY IMAGES - kept as per requirement -->
                      <li v-if="singleInspectionBooking.residency_proof && singleInspectionBooking.residency_proof.length > 0"
                          class="pax-image-item">
                       <!-- <v-btn depressed
                               color="#74a533"
                               dark
                               class="pax-image-btn arial-text"
                               @click="openInspectionImageGallery()">
                          <v-icon left small>mdi-image-multiple</v-icon>
                          VIEW ALL IMAGES
                          <v-chip small
                                  color="white"
                                  text-color="#2d5016"
                                  class="ml-2 pax-image-count">
                            {{ singleInspectionBooking.residency_proof.length }}
                          </v-chip>
                        </v-btn> -->
                      </li>
                    </ol>
                  </v-card-text>
                </v-container>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>

        <!-- ACCOMMODATION SECTION -->
        <v-flex lg12>
          <v-expansion-panel popout class="custom-expansion-panel">
            <v-expansion-panel-content>
              <template slot="actions">
                <v-icon color="primary">$vuetify.icons.expand</v-icon>
              </template>
              <div slot="header" class="panel-header">
                <h5>ACCOMMODATION ({{ singleInspectionBooking.facility_bookings.length }})</h5>
              </div>
              <v-card class="details-card">
                <v-container>
                  <v-card-text class="details-content">
                    <ol class="facility-list">
                      <li v-for="(facility, key) in singleInspectionBooking.facility_bookings"
                          :key="key"
                          class="facility-item">
                        <router-link :to="{
                            name: 'Facility',
                            params: {
                              facility_id: facility.facility_id,
                            },
                          }"
                                     class="facility-link">
                          {{ facility.facility_name }}
                        </router-link>
                        <span v-if="facility.facility_catering_type_name" class="catering-type">
                          ({{ facility.facility_catering_type_name }})
                        </span>
                        <span class="facility-meta">
                          | {{ facility.facility_booking_guests }} Guest(s) | between
                          {{ formated_date(facility.facility_booking_check_in_date) }}
                          and
                          {{ formated_date(facility.facility_booking_check_out_date) }}
                        </span>
                      </li>
                    </ol>
                  </v-card-text>
                </v-container>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>

        <!-- ACTIVITIES SECTION -->
        <v-flex lg12>
          <v-expansion-panel popout class="custom-expansion-panel">
            <v-expansion-panel-content>
              <template slot="actions">
                <v-icon color="primary">$vuetify.icons.expand</v-icon>
              </template>
              <div slot="header" class="panel-header">
                <h5>ACTIVITIES ({{ singleInspectionBooking.inventory_bookings.length }})</h5>
              </div>
              <v-card class="details-card">
                <v-container>
                  <v-card-text class="details-content">
                    <ul class="activity-list">
                      <li v-for="(activity, key) in singleInspectionBooking.inventory_bookings"
                          :key="key"
                          class="activity-item">
                        <router-link :to="{
                            name: 'SingleInventory',
                            params: {
                              inventory_id: activity.inventory_id,
                            },
                          }"
                                     class="activity-link">
                          {{ activity.inventory_name }}
                        </router-link>
                        <span v-if="activity.time_frame" class="time-frame">
                          ({{ activity.time_frame }})
                        </span>
                        <span class="activity-meta">
                          | {{ activity.inventory_booking_guests }} Guest(s)
                          <span v-if="activity.pick_up_location" class="pickup-location">
                            to be picked up at <b>{{ activity.pick_up_location }}</b>
                          </span>
                          on
                          {{ formated_date(activity.inventory_booking_date) }}
                          <span class="discount-badge">[Discount: {{ activity.inventory_booking_discount_percentage }}%]</span>
                        </span>
                      </li>
                    </ul>
                  </v-card-text>
                </v-container>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>

        <!-- STATUS CARDS -->
        <v-flex lg12>
          <v-card flat
                  color="primary"
                  dark
                  class="status-card"
                  v-if="singleInspectionBooking.actual_booking_check_in_date !== null">
            <v-container>
              <div class="status-content">
                <p class="status-label">DATE CHECKED IN</p>
                <p class="status-value">
                  {{ formated_date(singleInspectionBooking.actual_booking_check_in_date) }}
                </p>
              </div>
            </v-container>
          </v-card>

          <v-card color="primary"
                  dark
                  flat
                  class="status-card"
                  v-if="singleInspectionBooking.actual_booking_check_in_date === null">
            <v-container>
              <div class="status-content">
                <p class="status-label">CHECK IN DATE</p>
                <p class="status-value">
                  {{ formated_date(singleInspectionBooking.booking_check_in_date) }}
                </p>
              </div>
            </v-container>
          </v-card>

          <v-card flat
                  color="orange"
                  dark
                  class="status-card"
                  v-if="singleInspectionBooking.actual_booking_check_out_date === null">
            <v-container>
              <div class="status-content">
                <p class="status-label">CHECK OUT DATE</p>
                <p class="status-value">
                  {{ formated_date(singleInspectionBooking.booking_check_out_date) }}
                </p>
              </div>
            </v-container>
          </v-card>

          <v-card color="orange"
                  dark
                  flat
                  class="status-card"
                  v-if="singleInspectionBooking.actual_booking_check_out_date !== null">
            <v-container>
              <div class="status-content">
                <p class="status-label">DATE CHECKED OUT</p>
                <p class="status-value">
                  {{ formated_date(singleInspectionBooking.actual_booking_check_out_date) }}
                </p>
              </div>
            </v-container>
          </v-card>

          <v-card flat color="#F8B229" dark class="status-card">
            <v-container>
              <div class="status-content">
                <p class="status-label">CURRENCY BOOKED IN</p>
                <p class="status-value">
                  {{ singleInspectionBooking.currency }}
                  {{ $roundOff(singleInspectionBooking.total_cost.toFixed(2)).replace(/(\d)(?=(\d{3})+\.)/g, "$1,") }}
                </p>
              </div>
            </v-container>
          </v-card>

          <v-card flat
                  color="orange"
                  dark
                  class="status-card"
                  v-if="singleInspectionBooking.booking_payment_status === 'Not Paid'">
            <v-container>
              <div class="status-content">
                <p class="status-label">
                  {{ singleInspectionBooking.booking_payment_status.toUpperCase() }}
                </p>
                <p class="status-meta">
                  Balance: {{ $localCurrency }}
                  {{
 $roundOff(convertBasedBookingCreationDate(
                    singleInspectionBooking.currency,
                    singleInspectionBooking.booking_payment_balance,
                    singleInspectionBooking.currency_buying_rate_at_time,
                    singleInspectionBooking.currency_selling_rate_at_time
                  ).amount).toLocaleString("en")
                  }}
                </p>
                <p class="status-meta">
                  Total Amount: {{ $localCurrency }}
                  {{
 $roundOff(convertBasedBookingCreationDate(
                    singleInspectionBooking.currency,
                    singleInspectionBooking.total_cost,
                    singleInspectionBooking.currency_buying_rate_at_time,
                    singleInspectionBooking.currency_selling_rate_at_time
                  ).amount).toLocaleString("en")
                  }}
                </p>
              </div>
            </v-container>
          </v-card>

          <v-card flat
                  color="primary"
                  dark
                  class="status-card"
                  v-if="singleInspectionBooking.booking_payment_status === 'Paid'">
            <v-container>
              <div class="status-content">
                <p class="status-label">
                  {{ singleInspectionBooking.booking_payment_status.toUpperCase() }}
                </p>
                <p class="status-value">
                  Total Amount: {{ $localCurrency }}
                  {{
 $roundOff(convertBasedBookingCreationDate(
                    singleInspectionBooking.currency,
                    singleInspectionBooking.total_cost,
                    singleInspectionBooking.currency_buying_rate_at_time,
                    singleInspectionBooking.currency_selling_rate_at_time
                  ).amount)
                  }}
                </p>
              </div>
            </v-container>
          </v-card>

          <v-card flat
                  color="#8c7ae6"
                  dark
                  class="status-card"
                  v-if="singleInspectionBooking.booking_payment_status === 'Complimentary'">
            <v-container>
              <div class="status-content">
                <p class="status-label">
                  {{ singleInspectionBooking.booking_payment_status.toUpperCase() }}
                </p>
                <p class="status-meta">
                  Total Amount: {{ $localCurrency }}
                  {{
 $roundOff(convertBasedBookingCreationDate(
                    singleInspectionBooking.currency,
                    singleInspectionBooking.total_cost,
                    singleInspectionBooking.currency_buying_rate_at_time,
                    singleInspectionBooking.currency_selling_rate_at_time
                  ).amount)
                  }}
                </p>
              </div>
            </v-container>
          </v-card>

          <v-card flat
                  color="#9b59b6"
                  dark
                  class="status-card"
                  v-if="singleInspectionBooking.booking_payment_status === 'To Invoice'">
            <v-container>
              <div class="status-content">
                <p class="status-label">
                  {{ singleInspectionBooking.booking_payment_status.toUpperCase() }}
                </p>
                <p class="status-meta">
                  Total Amount: {{ $localCurrency }}
                  {{
 $roundOff(convertBasedBookingCreationDate(
                    singleInspectionBooking.currency,
                    singleInspectionBooking.total_cost,
                    singleInspectionBooking.currency_buying_rate_at_time,
                    singleInspectionBooking.currency_selling_rate_at_time
                  ).amount)
                  }}
                </p>
              </div>
            </v-container>
          </v-card>

          <v-card flat
                  color="#487eb0"
                  dark
                  class="status-card"
                  v-if="singleInspectionBooking.booking_payment_status === 'Incomplete Payment'">
            <v-container>
              <div class="status-content">
                <p class="status-label">
                  {{ singleInspectionBooking.booking_payment_status.toUpperCase() }}
                </p>
                <p class="status-meta">
                  Balance: {{ $localCurrency }}
                  {{
 $roundOff(convertBasedBookingCreationDate(
                    singleInspectionBooking.currency,
                    singleInspectionBooking.booking_payment_balance,
                    singleInspectionBooking.currency_buying_rate_at_time,
                    singleInspectionBooking.currency_selling_rate_at_time
                  ).amount)
                  }}
                </p>
                <p class="status-meta">
                  Total Amount: {{ $localCurrency }}
                  {{
 $roundOff(convertBasedBookingCreationDate(
                    singleInspectionBooking.currency,
                    singleInspectionBooking.total_cost,
                    singleInspectionBooking.currency_buying_rate_at_time,
                    singleInspectionBooking.currency_selling_rate_at_time
                  ).amount)
                  }}
                </p>
              </div>
            </v-container>
          </v-card>

          <v-card flat
                  color="#107c22"
                  dark
                  class="status-card"
                  v-if="singleInspectionBooking.credit_note_issued">
            <v-container>
              <div class="status-content">
                <p class="status-label">CREDIT NOTE ISSUED</p>
                <p>
                  <span class="status-value"
                        v-if="singleInspectionBooking.credit_notes">
                    {{ formated_date(singleInspectionBooking.credit_notes[0].created_at) }}
                  </span>
                  <br /><br />
                  <span v-if="singleInspectionBooking.credit_notes" class="status-meta">
                    {{ singleInspectionBooking.credit_notes[0].credit_note_reason }}
                  </span>
                </p>
              </div>
            </v-container>
          </v-card>
        </v-flex>
      </v-flex>

      <!-- RIGHT PANEL -->
      <v-flex lg6 md6 sm12 xs12 class="right-panel">
        <v-flex lg12>
          <!-- INSPECT BOOKING SECTION -->
          <v-expansion-panel popout class="custom-expansion-panel">
            <v-expansion-panel-content>
              <template slot="actions">
                <v-icon color="primary">$vuetify.icons.expand</v-icon>
              </template>
              <div slot="header" class="panel-header">
                <h5>INSPECT BOOKING</h5>
              </div>
              <v-card flat class="inspect-card">
                <v-container>
                  <v-form @submit.prevent="postNote()" class="note-form">
                    <v-textarea label="Note"
                                v-model="note.note"
                                class="note-textarea"
                                outlined></v-textarea>
                    <v-switch color="#e74c3c"
                              label="Alert"
                              v-model="note.alert"
                              class="alert-switch"></v-switch>
                    <v-btn :depressed="true"
                           color="primary"
                           block
                           type="submit"
                           class="submit-btn">
                      Post Note
                    </v-btn>
                  </v-form>
                </v-container>
              </v-card>

              <v-card-title v-if="singleInspectionBooking.booking_ranger_notes.length > 0">
                <h4 class="section-header">
                  Check Point Notes
                </h4>
              </v-card-title>

              <v-card flat
                      v-for="(note, key) in singleInspectionBooking.booking_ranger_notes"
                      :key="key"
                      class="ranger-note-card">
                <v-container fluid>
                  <p class="note-content">
                    <span class="note-label">Note: </span>
                    {{ note.note }}
                  </p>
                  <p class="note-status">
                    <span v-if="note.alert === 'true'" class="alert-status">
                      Status:
                      <v-chip color="#cd201f" text-color="black" class="status-chip">
                        Alert
                      </v-chip>
                    </span>
                    <span v-else class="okay-status">
                      Status:
                      <v-chip color="primary" text-color="black" class="status-chip">
                        Okay
                      </v-chip>
                    </span>
                  </p>
                  <p class="note-meta">
                    <span class="meta-label">Note by: </span>
                    {{ note.user }}
                    <span class="meta-label">at </span>
                    {{ formated_date_time(note.created_at) }}
                  </p>
                </v-container>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- VERIFY RESIDENCY PROOFS SECTION -->
          <v-expansion-panel popout class="custom-expansion-panel">
            <v-expansion-panel-content>
              <template slot="header">
                <h5 class="panel-header">VERIFY RESIDENCY PROOFS</h5>
              </template>

              <table cellpadding="1"
                     cellspacing="1"
                     class="residency-table"
                     v-if="proofOfResidencyCheckIn.length > 0">
                <tbody>
                  <tr v-for="(residency, key) in proofOfResidencyCheckIn"
                      :key="key"
                      class="residency-row">
                    <td>
                      <v-text-field label="First Name"
                                    v-model="proofOfResidencyCheckIn[key].first_name"
                                    outlined
                                    dense
                                    class="residency-field"></v-text-field>
                    </td>
                    <td>
                      <v-text-field label="Last Name"
                                    v-model="proofOfResidencyCheckIn[key].last_name"
                                    outlined
                                    dense
                                    class="residency-field"></v-text-field>
                    </td>
                    <td>
                      <v-text-field label="Document Id"
                                    v-model="proofOfResidencyCheckIn[key].document_id"
                                    outlined
                                    dense
                                    class="residency-field"></v-text-field>
                    </td>
                    <td>
                      <v-switch v-model="proofOfResidencyCheckIn[key].inspected"
                                label="Verify"
                                color="primary"
                                class="verify-switch"></v-switch>
                    </td>
                    <td>
                      <v-text-field label="Notes"
                                    v-model="proofOfResidencyCheckIn[key].notes"
                                    outlined
                                    dense
                                    class="residency-field"></v-text-field>
                    </td>
                    <td>
                      <v-btn v-if="proofOfResidencyCheckIn[key].has_image"
                             small
                             icon
                             color="#74a533"
                             @click="viewProofImage(proofOfResidencyCheckIn[key])"
                             title="View Image">
                        <v-icon small>mdi-image-multiple</v-icon>
                      </v-btn>
                      <v-btn v-else
                             small
                             icon
                             disabled
                             color="grey">
                        <v-icon small>mdi-image-off</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </table>
              <v-btn :depressed="true"
                     @click="verifyResidencyProof()"
                     :loading="$loadingTrue"
                     color="info"
                     class="verify-btn">
                Confirm Proofs
              </v-btn>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-flex>
    </v-layout>

    <!-- INSPECTION IMAGE GALLERY DIALOG -->
    <v-dialog v-model="imageGalleryDialog" max-width="900px" persistent>
      <v-card>
        <v-card-title class="inspection-dialog-header">
          <v-icon left dark>mdi-image-multiple</v-icon>
          <span class="knockout-header">VERIFICATION IMAGES</span>
          <v-spacer></v-spacer>
          <span class="white--text caption mr-3">
            {{ galleryImages.length }} image(s)
          </span>
          <v-btn icon dark @click="imageGalleryDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
          <div v-if="galleryImages.length > 0" class="image-gallery">
            <v-layout row wrap>
              <v-flex v-for="(image, index) in galleryImages"
                      :key="index"
                      lg4 md4 sm6 xs12
                      class="pa-2">
                <v-card class="gallery-card"
                        elevation="2"
                        @click="openFullImage(image)">
                  <div class="gallery-thumbnail-wrapper">
                    <img :src="getImageSrc(image)"
                         class="gallery-thumbnail"
                         :alt="'Verification Image ' + (index + 1)" />
                    <div class="gallery-overlay">
                      <v-icon color="white" size="32">mdi-magnify-plus</v-icon>
                    </div>
                  </div>
                  <div class="gallery-meta pa-2">
                    <v-chip small color="#74a533" text-color="white" class="mr-2">
                      {{ image.proof_point }}
                    </v-chip>
                    <v-chip small
                            :color="isProofVerified(image) ? 'success' : 'warning'"
                            text-color="white"
                            class="mr-2">
                      <v-icon small left>
                        mdi-{{ isProofVerified(image) ? 'check-circle' : 'alert-circle' }}
                      </v-icon>
                      {{ isProofVerified(image) ? 'Verified' : 'Pending' }}
                    </v-chip>
                    <span class="caption grey--text">
                      {{ formated_date_time(image.created_at) }}
                    </span>
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
          </div>
          <div v-else class="text-center pa-4">
            <v-icon size="48" color="grey">mdi-image-off</v-icon>
            <p class="grey--text mt-2">No verification images available</p>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- SINGLE IMAGE DIALOG -->
    <v-dialog v-model="imageDialog" max-width="800px" persistent>
      <v-card>
        <v-card-title class="inspection-dialog-header">
          <v-icon left dark>mdi-image</v-icon>
          <span class="knockout-header">VERIFICATION IMAGE</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="imageDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
          <div v-if="viewingImage" class="image-container">
            <div class="image-meta mb-3">
              <v-chip small color="#74a533" text-color="white" class="mr-2">
                {{ viewingImage.first_name }} {{ viewingImage.last_name }}
              </v-chip>
              <v-chip small color="info" text-color="white" class="mr-2">
                {{ viewingImage.proof_point }}
              </v-chip>
              <v-chip small color="grey" text-color="white">
                {{ formated_date_time(viewingImage.created_at) }}
              </v-chip>
            </div>

            <div class="image-wrapper">
              <img :src="getImageSrc(viewingImage)"
                   class="verification-image"
                   alt="Verification Image"
                   @click="openFullImage(viewingImage)" />
            </div>

            <div class="image-actions mt-3 text-center">
              <v-btn small color="success" class="arial-text" @click="openFullImage(viewingImage)">
                <v-icon left small>mdi-open-in-new</v-icon>
                FULL SCREEN
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- FULLSCREEN IMAGE VIEWER -->
    <v-dialog v-model="viewingImageDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="black">
          <v-btn icon dark @click="viewingImageDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <span v-if="viewingImage" class="knockout-header">
              {{ viewingImage.first_name }} {{ viewingImage.last_name }} — VERIFICATION IMAGE
            </span>
            <span v-else class="knockout-header">VERIFICATION IMAGE</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="viewPreviousImage" v-if="currentGalleryIndex > 0">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <span class="white--text caption mx-2" v-if="galleryImages.length > 0">
            {{ currentGalleryIndex + 1 }} / {{ galleryImages.length }}
          </span>
          <v-btn icon dark @click="viewNextImage" v-if="currentGalleryIndex < galleryImages.length - 1">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="full-image-container">
          <img v-if="viewingImage"
               :src="getImageSrc(viewingImage)"
               class="full-verification-image"
               :alt="'Verification Image ' + (currentGalleryIndex + 1)" />
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    data() {
      return {
        active: null,
        localData: JSON.parse(localStorage.getItem("unem")),
        dialog: false,
        dialog1: false,
        search: "",
        currency_id: "",
        note: {
          booking_id: this.$route.params.booking_id,
          note: "",
          show_on_invoice: false,
          ranger_note: 1,
          alert: false,
        },
        columns: [
          { text: "Timestamp", name: "created_at" },
          { text: "Activity", name: "booking_activity_description" },
          { text: "User", name: "session_user" },
        ],
        residencyProofColumns: [
          { text: "Name" },
          { text: "Residency" },
          { text: "Document ID" },
          { text: "Verified" },
          { text: "Verify" },
        ],
        imageGalleryDialog: false,
        galleryImages: [],
        imageDialog: false,
        viewingImage: null,
        viewingImageDialog: false,
        currentGalleryIndex: 0,
      };
    },

    methods: {
      totalGuestsVehicles() {
        let total = 0;
        if (this.singleInspectionBooking.guests.length > 0) {
          for (let x = 0; x < this.singleInspectionBooking.guests.length; x++) {
            if (this.singleInspectionBooking.guests[x].payment_guests > 0) {
              total = total + this.singleInspectionBooking.guests[x].payment_guests;
            }
          }
        }
        if (this.singleInspectionBooking.vehicles.length > 0) {
          for (let x = 0; x < this.singleInspectionBooking.vehicles.length; x++) {
            if (this.singleInspectionBooking.vehicles[x].vehicles > 0) {
              total = total + this.singleInspectionBooking.vehicles[x].vehicles;
            }
          }
        }
        return total;
      },

      printReceipt() {
        var data = {
          booking_id: this.$route.params.booking_id,
          currency_id: this.currency_id,
          session_id: localStorage.getItem("lkjhgfdsa"),
        };
        this.$store.dispatch("print_receipt", data);
        this.dialog1 = false;
      },

      postNote() {
        this.$store.dispatch("post_ranger_note", this.note);
        this.note = {
          booking_id: this.$route.params.booking_id,
          note: "",
          ranger_note: 1,
        };
      },

verifyResidencyProof() {
  const session_id = localStorage.getItem("lkjhgfdsa");
  const booking_id = this.$route.params.booking_id;

  const summary = this.proofOfResidencyCheckIn
    .filter(p => p.inspected)
    .map(p => `${p.first_name} ${p.last_name} — Doc ${p.document_id} — ${p.notes || 'ok'}`)
    .join("; ");

  const payload = {
    booking_id,
    note: `Residency proofs confirmed: ${summary || 'none marked'}`,
    session_id,
    alert: false,
    ranger_note: 1,
  };

  this.$store.dispatch("post_ranger_note", payload);
},

      populateCurrencyValue: function () {
        this.currency_id = this.singleInspectionBooking.currency_id;
      },

      getResidencyProofs() {
        let proofs = [];
        if (this.singleInspectionBooking && this.singleInspectionBooking.residency_proof) {
          proofs = this.singleInspectionBooking.residency_proof;
        }
        return proofs;
      },

      getGuestVerifiedImages(guest) {
        const proofs = this.getResidencyProofs();
        return proofs.filter(p =>
          p.payment_person === guest.payment_person &&
          (p.verified === 'Yes' || p.verified === true || p.inspected === true) &&
          p.has_image === true &&
          p.image_data
        );
      },

      isGuestVerifiable(guest) {
        return this.requiredVerificationGuests.includes(guest.payment_person);
      },

      getVerifiedCountForGuest(guest) {
        const proofs = this.getResidencyProofs();
        return proofs.filter(p =>
          p.payment_person === guest.payment_person &&
          (p.verified === 'Yes' || p.verified === true || p.inspected === true)
        ).length;
      },

      getGuestDocumentType(guest) {
        const lower = (guest.payment_person || '').toLowerCase();
        if (lower.includes('citizen child')) return 'exempt';
        if (lower.includes('citizen student')) return 'exempt';
        if (lower.includes('infant')) return 'exempt';
        if (lower.includes('non resident child')) return 'exempt';
        if (lower.includes('non resident adult')) return 'exempt';
        if (lower.includes('non resident student')) return 'exempt';
        if (lower.includes('ea resident child')) return 'exempt';
        if (lower.includes('citizen')) return 'kenyan_id';
        if (lower.includes('ea resident')) return 'work_permit';
        if (lower.includes('non resident')) return 'passport';
        if (lower.includes('school driver')) return 'kenyan_id';
        if (lower.includes('resident')) return 'work_permit';
        return 'passport';
      },

      getGuestDocTypeLabel(guest) {
        const type = this.getGuestDocumentType(guest);
        const labels = {
          'passport': 'Passport',
          'kenyan_id': 'Kenyan ID',
          'work_permit': 'Work Permit',
          'exempt': 'Exempt'
        };
        return labels[type] || 'Passport';
      },

      getGuestDocTypeColor(guest) {
        const type = this.getGuestDocumentType(guest);
        const colors = {
          'passport': 'success',
          'kenyan_id': 'primary',
          'work_permit': 'info',
          'exempt': 'grey'
        };
        return colors[type] || 'success';
      },

      getGuestDocTypeIcon(guest) {
        const type = this.getGuestDocumentType(guest);
        const icons = {
          'passport': 'passport',
          'kenyan_id': 'card-account-details',
          'work_permit': 'card-account-details',
          'exempt': 'check-circle'
        };
        return icons[type] || 'document';
      },

      viewGuestVerificationImages(guest) {
        const images = this.getGuestVerifiedImages(guest);
        if (images.length === 0) {
          this.$toast.warning('No images available for this verification');
          return;
        }
        this.galleryImages = images;
        this.currentGalleryIndex = 0;
        this.viewingImage = images[0];
        this.imageGalleryDialog = true;
        this.logImageView("gallery opened for " + guest.payment_person);
      },

      viewProofImage(proof) {
        if (!proof || !proof.image_data) {
          this.$toast.warning('No image available for this verification');
          return;
        }
        this.galleryImages = [proof];
        this.currentGalleryIndex = 0;
        this.viewingImage = proof;
        this.imageDialog = true;
        this.logImageView("image viewed");
      },

      openInspectionImageGallery() {
        const proofs = this.singleInspectionBooking.residency_proof || [];
        const withImages = proofs.filter(p => p.has_image === true && p.image_data);
        if (withImages.length === 0) {
          this.$toast.warning('No verification images available for this booking');
          return;
        }
        this.galleryImages = withImages;
        this.currentGalleryIndex = 0;
        this.viewingImage = withImages[0];
        this.imageGalleryDialog = true;
        this.logImageView("gallery opened");
      },

      isProofVerified(proof) {
        if (!proof) return false;
        return proof.verified === 'Yes' || proof.verified === true || proof.inspected === true;
      },

      getImageSrc(item) {
        if (!item || !item.image_data) return '';
        const mimeType = item.image_mime_type || 'image/jpeg';
        return `data:${mimeType};base64,${item.image_data}`;
      },

      openFullImage(item) {
        this.viewingImage = item;
        this.currentGalleryIndex = this.galleryImages.indexOf(item);
        this.viewingImageDialog = true;
        this.logImageView("image viewed fullscreen");
      },

      viewNextImage() {
        if (this.currentGalleryIndex < this.galleryImages.length - 1) {
          this.currentGalleryIndex++;
          this.viewingImage = this.galleryImages[this.currentGalleryIndex];
        }
      },

      viewPreviousImage() {
        if (this.currentGalleryIndex > 0) {
          this.currentGalleryIndex--;
          this.viewingImage = this.galleryImages[this.currentGalleryIndex];
        }
      },

      logImageView(description) {
        if (!this.$store._actions["log_image_view"]) return;
        this.$store.dispatch("log_image_view", {
          booking_id: this.$route.params.booking_id,
          session_id: localStorage.getItem("lkjhgfdsa"),
          description: description
        });
      },
    },

    beforeCreate() {
      this.$store.dispatch(
        "get_inspection_booking",
        this.$route.params.booking_id
      );
      this.$store.dispatch(
        "get_booking_checkin",
        this.$route.params.booking_id
      );
    },

    computed: {
      requiredVerificationGuests() {
        const checkin = this.$store.state.BookingStore.booking_checkin;
        if (!checkin || !checkin.residency_proof) return [];
        return checkin.residency_proof.map(p => p.payment_person);
      },

      proofOfResidencyCheckInData: function () {
        let residency_proof_db = this.singleInspectionBooking.residency_proof;
        if (residency_proof_db == undefined) {
          residency_proof_db = [];
        }
        this.$store.commit("CONSERVATION_FEES_PROOF_CHECKIN", residency_proof_db);
      },

      verifiableGuestTypes() {
        return this.singleInspectionBooking.guests.filter(
          g => g.payment_guests > 0 &&
               this.requiredVerificationGuests.includes(g.payment_person)
        );
      },

      exemptGuestTypes() {
        return this.singleInspectionBooking.guests.filter(
          g => g.payment_guests > 0 &&
               !this.requiredVerificationGuests.includes(g.payment_person)
        );
      },

      proofOfResidencyCheckIn: function () {
        return this.$store.state.ConservationFeeStore.conservation_fees_proof_checkin;
      },
    },
  };
</script>

<style>
  @font-face {
    font-family: 'Earthwerk';
    src: url('./PizzaDude.dk-Earthwerk.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Knockout';
    src: url('./knockout.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  .booking-inspection-container {
    background-color: #f5f7fa;
    padding: 20px;
  }

  .left-panel, .right-panel {
    padding: 0 15px;
  }

  .custom-expansion-panel {
    margin-bottom: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
  }

  .panel-header {
    font-family: 'Earthwerk', sans-serif;
    color: #2c3e50;
    font-size: 1.2rem;
    letter-spacing: 1px;
    padding: 12px 0;
  }

  .details-card {
    border-radius: 8px;
    background-color: #ffffff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  }

  .details-content {
    font-family: 'Arial', sans-serif;
    color: #34495e;
    padding: 15px;
  }

  .detail-label {
    font-family: 'Knockout', sans-serif;
    font-weight: bold;
    color: #2c3e50;
    margin-right: 5px;
  }

  .detail-value {
    color: #7f8c8d;
  }

  .section-header {
    font-family: 'Knockout', sans-serif;
    color: #2c3e50;
    margin: 15px 0 10px 0;
    font-size: 1.1rem;
  }

  .divider {
    border-color: #ecf0f1;
    margin: 15px 0;
  }

  .note-card {
    background-color: #f8f9fa;
    border-left: 4px solid #3498db;
    margin-bottom: 15px;
    border-radius: 4px;
  }

  .internal-chip {
    background-color: #95a5a6 !important;
    color: black !important;
  }

  .note-content {
    margin: 10px 0;
    line-height: 1.5;
  }

  .note-label {
    font-family: 'Knockout', sans-serif;
    color: #2c3e50;
  }

  .note-meta {
    font-size: 0.85rem;
    color: #7f8c8d;
  }

  .meta-label {
    font-family: 'Knockout', sans-serif;
    color: #95a5a6;
  }

  .guest-item, .vehicle-item {
    margin: 8px 0;
    padding: 5px;
    background-color: #f8f9fa;
    border-radius: 4px;
  }

  .guest-type, .vehicle-type {
    font-family: 'Knockout', sans-serif;
    color: #2c3e50;
  }

  .discount-badge {
    background-color: #f39c12;
    color: #587e27;
    padding: 2px 5px;
    border-radius: 3px;
    font-size: 0.8rem;
    margin-left: 5px;
  }

  /* ================= GUEST ROW WITH INLINE VERIFICATION ================= */
  .guest-item-with-verification {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 8px 10px;
  }

  .guest-row-main {
    font-size: 0.95rem;
    line-height: 1.4;
  }

  .guest-row-verification {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
  }

  .guest-row-verification .verification-chip {
    font-size: 0.7rem;
    height: 24px;
  }

  .doc-type-chip {
    font-size: 0.7rem;
    height: 24px;
  }

  .vehicle-detail-item {
    margin: 10px 0;
  }

  .facility-list, .activity-list {
    list-style-type: none;
    padding-left: 0;
  }

  .facility-item, .activity-item {
    margin: 10px 0;
    padding: 10px;
    background-color: #f8f9fa;
    border-radius: 4px;
  }

  .facility-link, .activity-link {
    color: #3498db;
    text-decoration: none;
    font-weight: bold;
  }

    .facility-link:hover, .activity-link:hover {
      text-decoration: underline;
    }

  .catering-type, .time-frame {
    color: #7f8c8d;
    font-style: italic;
  }

  .facility-meta, .activity-meta {
    color: #7f8c8d;
    font-size: 0.9rem;
  }

  .pickup-location {
    color: #2c3e50;
  }

  .status-card {
    margin-bottom: 15px;
    border-radius: 8px;
    transition: all 0.3s ease;
  }

    .status-card:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

  .status-content {
    padding: 15px;
  }

  .status-label {
    font-family: 'Knockout', sans-serif;
    font-size: 0.9rem;
    margin-bottom: 5px;
    color: #587e27;
  }

  .status-value {
    font-family: 'Earthwerk', sans-serif;
    font-size: 1.4rem;
    margin: 5px 0;
    color: #587e27;
  }

  .status-meta {
    font-family: 'Earthwerk', sans-serif;
    font-size: 1.4rem;
    margin: 5px 0;
    color: #587e27;
  }

  .inspect-card {
    background-color: #ffffff;
    border-radius: 8px;
  }

  .note-form {
    padding: 15px;
  }

  .note-textarea {
    margin-bottom: 15px;
  }

  .alert-switch {
    margin-bottom: 15px;
  }

  .submit-btn {
    font-family: 'Knockout', sans-serif;
    letter-spacing: 1px;
    height: 45px !important;
  }

  .ranger-note-card {
    background-color: #f8f9fa;
    border-left: 4px solid #e74c3c;
    margin-bottom: 15px;
    border-radius: 4px;
    padding: 10px;
  }

  .note-status {
    margin: 5px 0;
  }

  .alert-status, .okay-status {
    font-family: 'Knockout', sans-serif;
  }

  .status-chip {
    font-family: 'Knockout', sans-serif;
    letter-spacing: 1px;
  }

  .residency-table {
    width: 100%;
    margin-bottom: 15px;
    border-collapse: separate;
    border-spacing: 0 10px;
  }

  .residency-row {
    background-color: #ffffff;
  }

    .residency-row td {
      padding: 5px;
    }

  .residency-field {
    font-size: 0.85rem;
  }

  .verify-switch {
    margin-top: 0;
    padding-top: 0;
  }

  .verify-btn {
    font-family: 'Knockout', sans-serif;
    letter-spacing: 1px;
    height: 45px !important;
    margin-top: 10px;
  }

  /* ================= PAX IMAGE BUTTON (VIEW ALL) ================= */
  .pax-image-item {
    margin: 12px 0 4px 0;
    list-style: none;
  }

  .pax-image-btn {
    background: linear-gradient(135deg, #74a533 0%, #5c8428 100%) !important;
    color: #ffffff !important;
    border-radius: 30px !important;
    letter-spacing: 1px;
    font-weight: 600;
    padding: 0 18px !important;
    box-shadow: 0 4px 14px rgba(116, 165, 51, 0.30);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }

  .pax-image-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 22px rgba(116, 165, 51, 0.45);
  }

  .pax-image-count {
    font-weight: 700;
    font-size: 0.75rem;
  }

  /* ================= DIALOG HEADER ================= */
  .inspection-dialog-header {
    background: linear-gradient(145deg, #2d5016, #4a7c2b);
    color: #ffffff;
    display: flex;
    align-items: center;
  }

  .inspection-dialog-header .knockout-header {
    color: #ffffff;
    letter-spacing: 1.5px;
    font-weight: 700;
  }

  /* ================= GALLERY ================= */
  .image-gallery {
    max-height: 70vh;
    overflow-y: auto;
  }

  .gallery-card {
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    height: 100%;
    border: 1px solid rgba(116, 165, 51, 0.15);
  }

  .gallery-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 25px rgba(116, 165, 51, 0.20);
    border-color: rgba(116, 165, 51, 0.35);
  }

  .gallery-thumbnail-wrapper {
    position: relative;
    width: 100%;
    padding-top: 75%;
    background: #f5f5f5;
    overflow: hidden;
  }

  .gallery-thumbnail {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .gallery-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(45, 80, 22, 0.45);
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  .gallery-card:hover .gallery-overlay {
    opacity: 1;
  }

  .gallery-meta {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
  }

  /* ================= SINGLE IMAGE ================= */
  .image-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .image-wrapper {
    width: 100%;
    max-height: 500px;
    overflow: hidden;
    border-radius: 10px;
    border: 1px solid rgba(116, 165, 51, 0.20);
    background: #f5f5f5;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .verification-image {
    max-width: 100%;
    max-height: 500px;
    object-fit: contain;
    cursor: pointer;
    transition: transform 0.2s ease;
  }

  .verification-image:hover {
    transform: scale(1.02);
  }

  .image-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
  }

  .image-actions {
    display: flex;
    gap: 12px;
    justify-content: center;
  }

  /* ================= FULLSCREEN ================= */
  .full-image-container {
    width: 100vw;
    height: calc(100vh - 64px);
    display: flex;
    justify-content: center;
    align-items: center;
    background: #000;
    padding: 20px;
  }

  .full-verification-image {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  /* ================= RESPONSIVE ================= */
  @media (max-width: 600px) {
    .verification-image { max-height: 300px; }
    .image-wrapper { max-height: 300px; }
    .full-image-container { padding: 10px; }
    .gallery-thumbnail-wrapper { padding-top: 100%; }
    .image-gallery { max-height: 60vh; }
    .guest-row-verification { flex-direction: column; align-items: flex-start; }
  }
</style>